import { IShipmentStates } from 'types/graphqlTypes'

interface IUseRemoveHoldButtonProps {
  state?: IShipmentStates
}

/**
 * Handles visibility state of 'Remove hold' button
 */
export const useRemoveHoldButton = ({ state }: IUseRemoveHoldButtonProps) => {
  const isOnHold = state && state === IShipmentStates.on_hold

  return { isVisible: isOnHold }
}
